module.exports = __webpack_public_path__ + "img/completion9.84f88fd3.svg";